/**
 * Method: initAjaxForm
 *
 * Default ajax form method.
 * Adding class ajax-form to form enables sending over ajax.
 * Response replace the form.
 *
 * data-replace - what should be replaced with response
 *
 * @return void
 */
export function initAjaxForm() {
  function formSubmit(form, method) {
    var replace = form;
    if (form.data('replace')) {
      replace = $(form.data('replace'));
    }
    replace[0].style.opacity = '0.5';

    var xhr = new XMLHttpRequest();
    var url = form.attr('action');
    if (method === 'GET') {
      url += '?' + form.serialize();
    }

    xhr.open(method, url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    //xhr.setRequestHeader('X-CSRF-Token', form.find('[name="_csrfToken"]').val());
    xhr.onreadystatechange = function (response) {
      if (this.readyState !== 4) return;

      if (this.status == 200) {
        replace.replaceWith(this.responseText);
        if ($('.cart-no-data').length) {
          $('.stripe-checkout').hide();
          $('.cart-widget').hide();
        }
      } else {
        var error =
          '<div role="alert" class="alert alert-danger">Your request could not be sent. Please, try to reload page and send again.</div>';
        replace.find('.alert').remove();
        replace.prepend(error);
        replace[0].style.opacity = '1.0';
      }
    };
    if (method === 'POST') {
      var data = new FormData(form[0]);
      xhr.send(data);
    } else {
      xhr.send();
    }
  }

  $('body').on('submit', '.ajax-form', function (e) {
    if (window.FormData === undefined) return;

    e.preventDefault();

    var _this = $(this);

    formSubmit(_this, 'POST');
  });

  $('body').on('submit', '.ajax-form-get', function (e) {
    if (window.FormData === undefined) return;

    e.preventDefault();

    var _this = $(this);

    formSubmit(_this, 'GET');
  });
}

/**
 * Method: initAjaxLink
 *
 * Just send ajax by href
 * data-content - where the response should be append to
 * data-replace - what ther response should replace
 * data-url (optional) - what url should be used for ajax call (default href)
 *
 * @param callback call after ajax request is done
 * @return void
 */
export function initAjaxLink(callback) {
  $('body').on('click', '.ajax-link', function (e) {
    e.preventDefault();

    var _this = $(this);

    var xhr = new XMLHttpRequest();

    var url = _this.attr('href');
    if (_this.attr('data-url')) {
      url = _this.attr('data-url');
    }

    var contentContainer = _this.attr('data-content');
    $(contentContainer).addClass('ajax-disable');

    var replaceContainer = _this.attr('data-replace');
    $(replaceContainer).addClass('ajax-disable');

    var replaceUrl = _this.attr('data-replace-url');

    xhr.open('GET', url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function (response) {
      if (this.readyState == 4 && this.status == 200) {
        if (this.responseText !== '') {
          if (contentContainer) {
            $(contentContainer)
              .append(this.responseText)
              .removeClass('ajax-disable');
          }
          if (replaceContainer) {
            $(replaceContainer).replaceWith(this.responseText);
          }
          if (replaceUrl) {
            history.pushState({}, null, url);
          }
          if (callback) {
            callback();
          }
        }
      }
    };
    xhr.send();
  });
}
